import { render, staticRenderFns } from "./GameSettingsMatchEmails.vue?vue&type=template&id=2d19a8fa&"
import script from "./GameSettingsMatchEmails.vue?vue&type=script&lang=js&"
export * from "./GameSettingsMatchEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VFlex,VLayout,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d19a8fa')) {
      api.createRecord('2d19a8fa', component.options)
    } else {
      api.reload('2d19a8fa', component.options)
    }
    module.hot.accept("./GameSettingsMatchEmails.vue?vue&type=template&id=2d19a8fa&", function () {
      api.rerender('2d19a8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/GameSettingsMatchEmails.vue"
export default component.exports